/* Trade-price / professional mode has been retired: one price for everyone.
   This file only cleans up what older versions left in the visitor's browser. */
(() => {
  try {
    Object.keys(localStorage).forEach((k) => { if (/^cs[-_]?(pro|mode|vat|trade|customer)/i.test(k)) localStorage.removeItem(k); });
    Object.keys(sessionStorage).forEach((k) => { if (/^cs[-_]?(pro|mode|vat|trade|customer)/i.test(k)) sessionStorage.removeItem(k); });
  } catch (e) {}
  document.documentElement.classList.remove('cs-pro');
  const clean = () => {
    document.documentElement.classList.remove('cs-pro');
    document.querySelectorAll('.cs-modal, [data-cs-mode-switch], .cs-was, .cs-tradetag').forEach((el) => el.remove());
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', clean) : clean();
})();
